import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-search-card-units",
  templateUrl: "./card-units.component.html",
})
export class SearchCardUnitsComponent implements OnInit {
  public _color: string = "bg-black";
  public _icon: string = "fa fa-times";
  @Input()
  get unidad(): any {
    return this._unidad;
  }
  set unidad(unidad: any) {
    this._unidad = unidad === undefined ? null : unidad;
    if (this.unidad) {
      this._icon =
        this._unidad.Estado == "R"
          ? "fa fa-road"
          : this._unidad.Estado == "Y"
          ? "fa fa-home"
          : this._unidad.Estado == "A"
          ? "fa fa-user"
          : this._unidad.Estado == "T"
          ? "fa fa-tools"
          : "";
      this._color =
        this._unidad.Estado == "R"
          ? "bg-emerald-500"
          : this._unidad.Estado == "Y"
          ? "bg-pink-500"
          : this._unidad.Estado == "A"
          ? "bg-orange-500"
          : this._unidad.Estado == "T"
          ? "bg-red-500"
          : "";
    }
  }
  private _unidad = null;

  constructor() {}

  ngOnInit(): void {}
}
